module.exports = __webpack_public_path__ + "static/media/trivia.ccee1691.jpg";